import { Box, Text } from '@chakra-ui/react'
import React from 'react'

export const Footer = () => {
  return (
    <Box width={"100%"} height={"5vh"}>
        <Text align={"center"}>@arnabadhikary</Text>
    </Box>
  )
}
